(function($g, createjs, M) {

    var Shape = createjs.Shape;
    var Container = createjs.Container;
    var Tween = createjs.Tween;

    function Message(stage, img, duration, text) {
        var me = this;
        var timeline;
        var intro = new Container();

        var timeline;
        var background = new createjs.Bitmap(img);
        //background.alpha = 0;
        intro.addChild(background);

        var elmTexteDebut = new createjs.Text(text, "70px avenir-light", "#000000");
        elmTexteDebut.x = 0;
        elmTexteDebut.y = 0;
        //elmTexteDebut.textBaseline = "alphabetic";
        intro.addChild(elmTexteDebut);

        function appear(parent) {
            parent.addChild(intro);
            updateSize();
        }
        function clear() {
            var p = intro.parent;
            if (p) {
                p.removeChild(intro);
            }
        }
        function updateSize() {
            change();
        }

        function change() {
            var ww = stage.canvas.width;
            var hh = stage.canvas.height;
            var b = background.getBounds();
            if (!b) {
                return;
            }
            var iwidth = b.width;
            var iheight = b.height;
            var wr = ww / iwidth;
            var hr = hh / iheight;
            var r = M.max(wr, hr);
            var cx = ww*0.5;
            var cy = hh*0.5;

            var scaler = r;
            var w = iwidth*scaler;
            var h = iheight*scaler;

            background.scaleX = scaler;
            background.scaleY = scaler;
            background.x = cx - w/2;
            background.y = cy - h/2;

            elmTexteDebut.x = cx;
            elmTexteDebut.y = cy - 50;

        };        

        this.show = appear;
        this.hide = clear;
        this.resize = updateSize;
        this.ready = true;    
    
        var init = function() {
            timeline = Tween.get(intro, {paused: true, onChange: change});
            timeline
                    .wait(duration);
            me.timeline = timeline;
        };

        init();        
    }

    $g.Message = Message;

})(PVPGEngine, createjs, Math);